// @ts-nocheck

(function (window) {
  "use strict";
  const ASSETS = window.ReceiptPrintAssets || {};

  const HTML2PDF_URL = ASSETS.html2pdf;
  const JSBARCODE_URL = ASSETS.jsbarcode;

  if (!HTML2PDF_URL || !JSBARCODE_URL) {
    console.error(
      "[receipt-print] window.ReceiptPrintAssets is missing html2pdf/jsbarcode URLs — check the section markup.",
    );
  }

  const TIME_ZONE = "Europe/London";

  const OPEN_ANIMATION_MS = 1100;
  const CLOSE_ANIMATION_MS = 320;

  // ---- A4 settings -------------------------------------------------------
  const A4_MARGIN_MM = 10;
  const A4_CONTENT_WIDTH_PX = Math.floor(
    ((210 - A4_MARGIN_MM * 2) * 96) / 25.4,
  );

  const MAX_CANVAS_PIXELS = 16000000;


  const READY_TIMEOUT_MS = 5000;

  const NO_BREAK_SELECTORS = [
    ".rp-header",
    ".rp-store-card",
    ".rp-products tr",
    ".rp-summary-grid",
    ".rp-payment",
    ".rp-barcode-card",
  ];

  const STYLE_ID = "rp-export-styles";

  const scriptPromises = {};

  function loadScript(url) {
    if (!url) return Promise.reject(new Error("No script URL given"));
    if (!scriptPromises[url]) {
      scriptPromises[url] = new Promise(function (resolve, reject) {
        const script = document.createElement("script");
        script.src = url;
        script.async = true;
        script.onload = resolve;
        script.onerror = function () {
          delete scriptPromises[url];
          script.remove();
          reject(new Error("Failed to load " + url));
        };
        document.head.appendChild(script);
      });
    }
    return scriptPromises[url];
  }

  function loadLibrary(url, globalName) {
    if (window[globalName]) return Promise.resolve(window[globalName]);
    return loadScript(url).then(function () {
      if (!window[globalName]) {
        throw new Error(
          "[receipt-print] " +
            url +
            " loaded but window." +
            globalName +
            " is missing",
        );
      }
      return window[globalName];
    });
  }

  // ---- styles needed for PDF + print (self-contained) ----------------------

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const noBreak = NO_BREAK_SELECTORS.map(function (s) {
      return ".rp-sheet--export " + s;
    }).join(",");

    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = [
      ".rp-sheet [hidden]{display:none!important}",
      ".rp-barcode{display:block;max-width:100%;height:auto;margin:0 auto}",

      // A clean, static copy of the sheet used for PDF and print:
      // no animation/transform, full available width.
      ".rp-sheet--export{width:100%!important;max-width:none!important;margin:0!important;" +
        "transform:none!important;animation:none!important;transition:none!important;" +
        "box-shadow:none!important;opacity:1!important}",
      ".rp-sheet--export *{animation:none!important;transition:none!important}",
      ".rp-sheet--export{padding:36px!important}",
      ".rp-sheet--export .rp-store-card{grid-template-columns:1fr 1.7fr!important}",
      ".rp-sheet--export .rp-summary-grid{grid-template-columns:1.1fr 1fr!important}",
      ".rp-sheet--export .rp-meta{grid-template-columns:repeat(3,minmax(0,1fr))!important}",
      ".rp-sheet--export .rp-products th{padding:10px 18px!important}",
      ".rp-sheet--export .rp-products td{padding:14px 18px!important}",
      noBreak + "{break-inside:avoid;page-break-inside:avoid}",
      ".rp-sheet--export .rp-card-title,.rp-sheet--export .rp-tax-title{break-after:avoid;page-break-after:avoid}",
      ".rp-sheet--export thead{display:table-header-group}", 

      ".rp-measure-host{position:absolute;top:0;left:-100000px;width:" +
        A4_CONTENT_WIDTH_PX +
        "px;visibility:hidden;pointer-events:none}",

      ".rp-print-root{display:none}",

      "@media print{",
      "html.receipt-printing,html.receipt-printing body{width:auto!important;height:auto!important;" +
        "min-height:0!important;max-height:none!important;overflow:visible!important;" +
        "margin:0!important;padding:0!important;background:#fff!important}",
      "html.receipt-printing body>*:not(.rp-print-root){display:none!important}",
      "html.receipt-printing .rp-print-root{display:block!important;position:static!important}",
      "html.receipt-printing .rp-print-root *{-webkit-print-color-adjust:exact!important;print-color-adjust:exact!important}",
      "}",
    ].join("\n");
    document.head.appendChild(style);
  }

  // ---- helpers ---------------------------------------------------------

  function el(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined && text !== null) node.textContent = String(text);
    return node;
  }

  function formatDate(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "";
    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      timeZone: TIME_ZONE,
    }).format(d);
  }

  function formatTime(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "";
    return new Intl.DateTimeFormat("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
      timeZone: TIME_ZONE,
    }).format(d);
  }

  function formatMoney(amount, currency) {
    const value = Number(amount);
    if (
      amount === null ||
      amount === undefined ||
      amount === "" ||
      isNaN(value)
    )
      return "";
    try {
      return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: currency || "GBP",
      }).format(value);
    } catch (err) {
      return (value < 0 ? "-" : "") + "£" + Math.abs(value).toFixed(2);
    }
  }

  function sum(list, key) {
    return list.reduce(function (total, item) {
      return total + (Number(item[key]) || 0);
    }, 0);
  }

  function compact(parts) {
    return parts.filter(function (part) {
      return part !== null && part !== undefined && String(part).trim();
    });
  }

  function withTimeout(promise, ms) {
    return Promise.race([
      promise,
      new Promise(function (resolve) {
        setTimeout(resolve, ms);
      }),
    ]);
  }

  function waitForImages(root) {
    if (!root) return Promise.resolve();
    const imgs = Array.prototype.slice.call(root.querySelectorAll("img"));
    return Promise.all(
      imgs.map(function (img) {
        if (img.complete) return null;
        return new Promise(function (resolve) {
          img.addEventListener("load", resolve, { once: true });
          img.addEventListener("error", resolve, { once: true });
        });
      }),
    );
  }

  // Resolves once fonts, images and (optionally) the barcode are ready.
  function whenRendered(node, extra) {
    const fonts =
      document.fonts && document.fonts.ready
        ? document.fonts.ready
        : Promise.resolve();
    return withTimeout(
      Promise.all([extra || Promise.resolve(), fonts, waitForImages(node)]),
      READY_TIMEOUT_MS,
    ).catch(function () {});
  }

  function forceEagerImages(root) {
    // Lazy images inside an off-screen / hidden copy never load.
    root.querySelectorAll("img").forEach(function (img) {
      img.loading = "eager";
    });
  }

  function cloneForExport(sheet) {
    const clone = sheet.cloneNode(true);
    clone.classList.add("rp-sheet--export");
    clone.removeAttribute("style");
    forceEagerImages(clone);
    return clone;
  }

  // ---- receipt sections ---------------------------------------------------------

  function buildHeader() {
    const header = el("div", "rp-header");

    const logo = el("div", "rp-logo");
    const logoTemplate = document.querySelector("[data-receipt-print-logo]");
    if (
      logoTemplate &&
      logoTemplate.content &&
      logoTemplate.content.firstElementChild
    ) {
      logo.appendChild(logoTemplate.content.cloneNode(true));
      forceEagerImages(logo);
    } else {
      logo.textContent = "bodycare+";
    }
    header.appendChild(logo);

    return header;
  }

  function buildMetaField(label, value) {
    const field = el("div", "rp-field");
    field.appendChild(el("p", "rp-label", label));
    field.appendChild(el("p", "rp-value", value));
    return field;
  }

  function buildStoreCard(raw) {
    const store = raw.storeInfo || {};
    const customer = raw.customer || {};
    const card = el("div", "rp-card rp-store-card");

    const storeCol = el("div", "rp-store");
    storeCol.appendChild(el("span", "rp-tag", "Store"));
    storeCol.appendChild(
      el("p", "rp-store-name", store.storeName || store.companyName || ""),
    );
    compact([
      store.address1,
      store.address2,
      store.city,
      store.postCode,
      store.country,
      store.phoneNumber
        ? compact([store.countryCode, store.phoneNumber]).join(" ")
        : "",
    ]).forEach(function (line) {
      storeCol.appendChild(el("p", "rp-store-line", line));
    });
    card.appendChild(storeCol);

    const meta = el("div", "rp-meta");
    [
      ["Issued To", compact([customer.firstName, customer.lastName]).join(" ")],
      ["Date Issued", formatDate(raw.dateTime || raw.createdAt)],
      ["Terminal ID", raw.terminalId || store.terminalId],
      ["Transaction ID", raw.transactionId],
      ["Store ID", raw.storeId || store.storeId],
      ["Store Name", store.storeName],
      ["VAT Number", store.vat],
    ].forEach(function (pair) {
      if (pair[1]) meta.appendChild(buildMetaField(pair[0], pair[1]));
    });
    card.appendChild(meta);

    return card;
  }

  function buildProductsCard(raw) {
    const products = (raw.basket && raw.basket.products) || [];
    const card = el("div", "rp-card");
    const table = el("table", "rp-table rp-products");

    const head = el("tr");
    ["Product", "Price", "Qty", "Total"].forEach(function (title) {
      head.appendChild(el("th", "", title));
    });
    const thead = el("thead");
    thead.appendChild(head);
    table.appendChild(thead);

    const tbody = el("tbody");
    if (!products.length) {
      const row = el("tr");
      const cell = el("td", "", "No items on this receipt");
      cell.colSpan = 4;
      row.appendChild(cell);
      tbody.appendChild(row);
    }
    products.forEach(function (p) {
      const row = el("tr");

      const nameCell = el("td");
      nameCell.appendChild(el("span", "rp-product-name", p.description || ""));
      if (p.SKU)
        nameCell.appendChild(el("span", "rp-product-sku", "SKU " + p.SKU));
      row.appendChild(nameCell);

      row.appendChild(el("td", "", formatMoney(p.price, raw.baseCurrency)));
      row.appendChild(el("td", "", p.quantity != null ? p.quantity : ""));
      row.appendChild(
        el("td", "", formatMoney(p.totalLinePrice, raw.baseCurrency)),
      );
      tbody.appendChild(row);
    });
    table.appendChild(tbody);

    card.appendChild(table);
    return card;
  }

  function buildSummaryCard(raw) {
    const summary = raw.basketSummary || {};
    const products = (raw.basket && raw.basket.products) || [];
    const taxSummary = (raw.basket && raw.basket.totalTaxSummary) || [];
    const currency = raw.baseCurrency;

    const card = el("div", "rp-card");
    card.appendChild(el("h2", "rp-card-title", "Summary"));

    const grid = el("div", "rp-summary-grid");

    const taxCol = el("div", "rp-tax");

    if (taxSummary.length) {
      taxCol.appendChild(el("p", "rp-tax-title", "Tax Breakdown"));

      const table = el("table", "rp-table rp-tax-table");
      const head = el("tr");
      ["Code", "Rate", "Net", "VAT", "Total"].forEach(function (title) {
        head.appendChild(el("th", "", title));
      });
      table.appendChild(head);

      taxSummary.forEach(function (line) {
        const row = el("tr");
        row.appendChild(el("td", "", line.VATCode || ""));
        row.appendChild(el("td", "", line.VAT != null ? line.VAT + "%" : ""));
        row.appendChild(el("td", "", formatMoney(line.PreTaxSum, currency)));
        row.appendChild(el("td", "", formatMoney(line.TaxSum, currency)));
        row.appendChild(el("td", "", formatMoney(line.TXrateSum, currency)));
        table.appendChild(row);
      });

      const totalRow = el("tr", "rp-tax-total");
      totalRow.appendChild(el("td", "", "TOTAL:"));
      totalRow.appendChild(el("td", "", ""));
      totalRow.appendChild(
        el("td", "", formatMoney(sum(taxSummary, "PreTaxSum"), currency)),
      );
      totalRow.appendChild(
        el("td", "", formatMoney(sum(taxSummary, "TaxSum"), currency)),
      );
      totalRow.appendChild(
        el("td", "", formatMoney(sum(taxSummary, "TXrateSum"), currency)),
      );
      table.appendChild(totalRow);
      taxCol.appendChild(table);
    }

    taxCol.appendChild(el("p", "rp-count", "Total Lines: " + products.length));
    if (summary.totalItems != null) {
      taxCol.appendChild(
        el("p", "rp-count", "Quantity of items: " + summary.totalItems),
      );
    }
    grid.appendChild(taxCol);

    const basketTotal =
      summary.shippingTotal > 0
        ? summary.basketTotalWithShippingTotal
        : summary.basketTotal;

    const totalBox = el("div", "rp-total-box");
    const totalLine = el("p", "rp-total-line");
    totalLine.appendChild(el("span", "rp-total-label", "Basket Total"));
    totalLine.appendChild(
      el("span", "rp-total-amount", formatMoney(basketTotal, currency)),
    );
    totalBox.appendChild(totalLine);
    if (summary.VATTotal != null) {
      totalBox.appendChild(
        el(
          "p",
          "rp-total-vat",
          "VAT Total: " + formatMoney(summary.VATTotal, currency),
        ),
      );
    }
    grid.appendChild(totalBox);

    card.appendChild(grid);
    return card;
  }

  function buildPaymentsCard(raw) {
    const payments = raw.paymentDetails || [];
    if (!payments.length) return null;

    const operator = raw.operatorDetails || {};
    const salesPerson =
      operator.printableName || operator.firstName || raw.userName || "";

    const card = el("div", "rp-card");
    card.appendChild(el("h2", "rp-card-title", "Payments"));

    const list = el("div", "rp-payments");
    payments.forEach(function (payment) {
      const when = payment.transactionDate || raw.dateTime;
      const type = String(payment.paymentType || "").toUpperCase();

      const box = el("div", "rp-payment");

      const bar = el("div", "rp-payment-bar");
      bar.appendChild(el("span", "", type));
      bar.appendChild(
        el(
          "span",
          "",
          formatMoney(
            payment.totalamount != null ? payment.totalamount : payment.amount,
            payment.currency || raw.baseCurrency,
          ),
        ),
      );
      box.appendChild(bar);

      const fields = el("div", "rp-payment-fields");
      [
        ["Payment Type", type],
        ["Type", payment.transactionType || raw.type],
        ["Result", payment.result],
        ["Date", formatDate(when)],
        ["Time", formatTime(when)],
        ["Sales Person", salesPerson],
      ].forEach(function (pair) {
        if (pair[1]) fields.appendChild(buildMetaField(pair[0], pair[1]));
      });
      box.appendChild(fields);

      list.appendChild(box);
    });
    card.appendChild(list);

    return card;
  }

  function buildBarcodeCard(raw) {
    const code = compact([raw.storeId, raw.transactionId]).join("-");
    const card = el("div", "rp-card rp-barcode-card");

    const img = el("img", "rp-barcode");
    img.alt = code ? "Barcode " + code : "";
    img.hidden = true;
    card.appendChild(img);
    if (code) card.appendChild(el("p", "rp-barcode-text", code));
    card.appendChild(
      el("p", "rp-thanks", "Thanks for choosing us. It means a lot."),
    );

    let ready = Promise.resolve();
    if (code) {
      ready = loadLibrary(JSBARCODE_URL, "JsBarcode")
        .then(function (JsBarcode) {
          const canvas = document.createElement("canvas");
          JsBarcode(canvas, code, {
            format: "CODE128",
            displayValue: false,
            width: 2,
            height: 90,
            margin: 0,
          });
          return new Promise(function (resolve) {
            img.onload = function () {
              img.hidden = false;
              resolve();
            };
            img.onerror = resolve;
            img.src = canvas.toDataURL("image/png");
          });
        })
        .catch(function (err) {
          console.error("[receipt-print] Could not render barcode:", err);
        });
    }

    return { card: card, ready: ready };
  }

  function buildSheet(raw) {
    const sheet = el("div", "rp-sheet");
    const barcode = buildBarcodeCard(raw);

    sheet.appendChild(buildHeader());
    sheet.appendChild(buildStoreCard(raw));
    sheet.appendChild(buildProductsCard(raw));
    sheet.appendChild(buildSummaryCard(raw));
    const payments = buildPaymentsCard(raw);
    if (payments) sheet.appendChild(payments);
    sheet.appendChild(barcode.card);

    return { sheet: sheet, ready: barcode.ready };
  }

  // ---- print ---------------------------------------------------------

  let printCleanup = null;

  function preparePrint(sheet) {
    if (printCleanup) return;
    ensureStyles();

    const html = document.documentElement;
    const root = el("div", "rp-print-root");
    root.appendChild(cloneForExport(sheet));
    document.body.appendChild(root);

    const pageStyle = document.createElement("style");
    pageStyle.textContent =
      "@page{size:A4 portrait;margin:" + A4_MARGIN_MM + "mm}";
    document.head.appendChild(pageStyle);

    html.classList.add("receipt-printing");

    function cleanup() {
      if (printCleanup !== cleanup) return;
      printCleanup = null;
      html.classList.remove("receipt-printing");
      root.remove();
      pageStyle.remove();
      window.removeEventListener("afterprint", cleanup);
    }

    window.addEventListener("afterprint", cleanup);
    printCleanup = cleanup;
  }

  function cleanupPrint() {
    if (printCleanup) printCleanup();
  }

  function printSheet(sheet, ready, button) {
    if (button) button.disabled = true;

    whenRendered(sheet, ready)
      .then(function () {
        cleanupPrint();
        preparePrint(sheet);
        return whenRendered(document.querySelector(".rp-print-root"));
      })
      .then(function () {
        window.print();
      })
      .finally(function () {
        if (button) button.disabled = false;
      });
  }

  // ---- PDF ---------------------------------------------------------

  function downloadPdf(sheet, ready, filename, button) {
    if (button.disabled) return;
    const idleLabel = button.textContent;
    button.disabled = true;
    button.textContent = "Preparing…";

    let host = null;

    Promise.all([
      loadLibrary(HTML2PDF_URL, "html2pdf"),
      whenRendered(sheet, ready),
    ])
      .then(function () {
        host = el("div", "rp-measure-host");
        const clone = cloneForExport(sheet);
        host.appendChild(clone);
        document.body.appendChild(host);
        return whenRendered(clone).then(function () {
          return clone;
        });
      })
      .then(function (clone) {
        const height = Math.max(clone.scrollHeight, 1);
        const scale = Math.max(
          1,
          Math.min(
            2,
            Math.sqrt(MAX_CANVAS_PIXELS / (A4_CONTENT_WIDTH_PX * height)),
          ),
        );

        return window
          .html2pdf()
          .set({
            margin: A4_MARGIN_MM,
            filename: filename,
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: {
              scale: scale,
              useCORS: true,
              // The real fix for "white space on top, cut at bottom":
              // don't let the page's scroll position offset the capture.
              scrollX: 0,
              scrollY: 0,
              // Don't set windowWidth: html2pdf centres its render box in the
              // window, and a different virtual width shifts/crops the capture.
              // The desktop layout is forced with .rp-sheet--export CSS instead.
              backgroundColor: "#ffffff",
              logging: false,
            },
            jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
            pagebreak: { mode: ["css", "legacy"], avoid: NO_BREAK_SELECTORS },
          })
          .from(clone)
          .save();
      })
      .catch(function (err) {
        console.error(
          "[receipt-print] PDF download failed, falling back to print:",
          err,
        );
        printSheet(sheet, ready);
      })
      .finally(function () {
        if (host) host.remove();
        button.disabled = false;
        button.textContent = idleLabel;
      });
  }

  // ---- overlay ---------------------------------------------------------

  let activeClose = null;

  function open(raw) {
    if (!raw) return;

    if (activeClose) activeClose(true);

    ensureStyles();

    const overlay = el("div", "rp-overlay");
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.setAttribute("aria-label", "Receipt");

    const built = buildSheet(raw);
    const sheet = built.sheet;
    const ready = built.ready;

    const safeId = String(raw.transactionId || raw.id || "receipt").replace(
      /[^\w.-]+/g,
      "_",
    );
    const filename = "bodycare-receipt-" + safeId + ".pdf";

    const toolbar = el("div", "rp-toolbar");
    const downloadBtn = el("button", "rp-btn rp-btn--primary", "Download PDF");
    const printBtn = el("button", "rp-btn", "Print");
    const closeBtn = el("button", "rp-btn", "Close");
    [downloadBtn, printBtn, closeBtn].forEach(function (button) {
      button.type = "button";
      toolbar.appendChild(button);
    });

    const previousOverflow = document.body.style.overflow;
    const previousFocus = document.activeElement;

    let closing = false;

    function finishClose() {
      cleanupPrint();
      document.body.style.overflow = previousOverflow;
      overlay.remove();
      if (previousFocus && typeof previousFocus.focus === "function") {
        try {
          previousFocus.focus({ preventScroll: true });
        } catch (e) {}
      }
    }

    function close(immediate) {
      if (closing) return;
      closing = true;
      if (activeClose === close) activeClose = null;
      document.removeEventListener("keydown", onKeydown);
      window.removeEventListener("beforeprint", onBeforePrint);

      const reducedMotion =
        window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      if (immediate === true || reducedMotion) {
        finishClose();
        return;
      }

      overlay.classList.remove("rp-opening");
      overlay.classList.add("rp-closing");
      setTimeout(finishClose, CLOSE_ANIMATION_MS);
    }

    function onKeydown(event) {
      if (event.key === "Escape") close();
    }

    function onBeforePrint() {
      preparePrint(sheet);
    }

    downloadBtn.addEventListener("click", function () {
      downloadPdf(sheet, ready, filename, downloadBtn);
    });
    printBtn.addEventListener("click", function () {
      printSheet(sheet, ready, printBtn);
    });
    closeBtn.addEventListener("click", function () {
      close();
    });
    overlay.addEventListener("click", function (event) {
      if (event.target === overlay) close();
    });
    document.addEventListener("keydown", onKeydown);
    window.addEventListener("beforeprint", onBeforePrint);

    overlay.appendChild(toolbar);
    overlay.appendChild(sheet);
    overlay.classList.add("rp-opening");
    setTimeout(function () {
      overlay.classList.remove("rp-opening");
    }, OPEN_ANIMATION_MS);

    document.body.appendChild(overlay);
    document.body.style.overflow = "hidden";
    downloadBtn.focus();

    activeClose = close;
  }

  window.ReceiptPrint = {
    open: open,
    loadScript: loadScript,
    loadLibrary: loadLibrary,
  };
})(window);
